module.exports = __webpack_public_path__ + "c_static/img/home_passed.386af8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/home_passed.png
// module id = ribC
// module chunks = 33